import dropdown from "./dropdown/dropdown.vue";
import datepicker from "vuejs-datepicker";
import titleUser from "./title-user.vue";
import cardTaxes from "./card-taxes.vue";
import vueDatePicker from "vue2-datepicker";
import FormVehicle from "./Pages/Adhesion/FormVehicle/FormVehicle.vue";
import dropdownV2 from "./Global/dropdownV2/dropdownV2.vue";
import loadingV2 from "./Global/Loading/Loading.vue";
import FormModal from "./Pages/Adhesion/form-modal/form-modal.vue";
import FormModalNewSearch from "./Pages/Adhesion/form-modal/form-modal-new-search.vue";
import FormAddVehicles from "./Pages/Adhesion/form-add-vehicles/form-add-vehicles.vue";
import "./datepicker.scss";
import CaptchaAdhesion from "./captcha/captcha.vue";
import HeaderHotSite from "../pages/common/hotsite/components/header/header-hot-site.vue";
import MainContentHotSite from "../pages/common/hotsite/components/mainContent/mainContent.vue";
import ModalValidate from "./modal-validate/modal-validate.vue";

const plugin = {};
plugin.install = function (Vue, options) {
  Vue.component("cardTaxes", cardTaxes);
  Vue.component("dropdown", dropdown);
  Vue.component("datepicker", datepicker);
  Vue.component("title-user", titleUser);
  Vue.component("vue-date-picker", vueDatePicker);
  Vue.component("form-vehicle", FormVehicle);
  Vue.component("dropdownV2", dropdownV2);
  Vue.component("loadingV2", loadingV2);
  Vue.component("form-modal", FormModal);
  Vue.component("form-modal-new-search", FormModalNewSearch);
  Vue.component("form-add-vehicles", FormAddVehicles);
  Vue.component("CaptchaAdhesion", CaptchaAdhesion);
  Vue.component("HeaderHotSite", HeaderHotSite);
  Vue.component("MainContentHotSite", MainContentHotSite);
  Vue.component("modal-validate", ModalValidate);
};

export default plugin;



// WEBPACK FOOTER //
// ./src/components/index.js